import * as I18n from 'circe/I18n';
import { NAME as APP_NAME } from 'domain/operations/constants';

export const ROUTES = {
  ROOT: '/shippers',
};

export const NAME = `${APP_NAME}/SHIPPER`;
export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/shippers?did=${SYSTEM_DOMAIN}&excludeDeactivated=true`;
export const REDUCER_NAME = 'shippers';

export const SHIPPER_STATUS = {
  ACTIVE: I18n.str('ACTIVE', 'ACTIVE'),
  INACTIVE: I18n.str('inactive', 'Inactive'),
  DEACTIVATED: I18n.str('deactivated', 'Deactivated'),
  PENDING_ACTIVATION: I18n.str('PENDING_ACTIVATION', 'PENDING_ACTIVATION'),
  SUSPENDED: I18n.str('SUSPENDED', 'SUSPENDED'),
};

export const SHIPPER_URL = '/waybills?shippers=';

export const REFERENCE_MODAL_FORM_NAME = 'REFERENCE_MODAL_FORM';
